module.exports = __webpack_public_path__ + "img/tc.bc4bf64b.svg";